import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { ImagensBase64 } from 'src/app/models/vos/imagens-base64';
@Injectable({
  providedIn: 'root'
})
export class GerarPdfOsService {

  constructor() {

  }

  geraPdf(item, usuario, logo) {
    // let imgRelatorio = new ImagensBase64;
    var doc = new jsPDF()
    let pdf_pages = doc.internal.pages;
    // doc.addImage(imgRelatorio.imgHeader2, 'JPEG', 0, 0, 210, 0)
    // doc.addImage(imgRelatorio.imgfooter, 'JPEG', 0, 290, 210, 0)
    let margin = 50
    doc.setFontSize(12)
    doc.setFontType('bold')
    doc.setTextColor(2, 50, 54)
    doc.text("Ordem de Serviço", 10, 42)
    doc.setDrawColor(2, 50, 54)
    doc.setLineWidth(0.5)
    doc.line(10, 45, 200, 45)
    doc.setLineWidth(0.1);

    //TIPO DE LICITAÇÃO
    ((doc as any).autoTable)({
      body: [[item.orcamento.tipo]],
      startY: 30,
      margin: { left: 130 },
      theme: 'grid',
      tableWidth: 'auto',
    });
    let montEquip = item.montagemequipe == true ? "Sim" : "Não";
    let realProced = item.realizacaoprocedimento == true ? "Sim" : "Não";
    //PERGUNTAS E NUMERO COTAÇÂO
    ((doc as any).autoTable)({
      body: [
        [["Montagem de Equipe?: " + montEquip], ["Realização de Proc.: " + realProced], ["Nº Orçamento: " + item.orcamento.numero]],
        [{ content: 'Convênio/Cliente: ' + `${item.orcamento?.cliente?.pessoa?.nome}`, colSpan: 3 }],
        [["Nº OS: " + `${item.codigo ? item.codigo : ""}`], ["Periodo: " + item.orcamento.quantidade + " " + item.orcamento.unidade], ["Inicio: " + `${item.inicio ? item.inicio : ""}` + " - Término: " + `${item.fim ? item.fim : ""}`]]
      ],
      startY: 50,
      theme: 'grid',
      tableWidth: 'auto',
    });
    //PACIENTE
    ((doc as any).autoTable)({
      head: [[{ colSpan: 3, content: "Paciente" }]],
      body: [
        [['NOME: ' + `${item.orcamento?.homecare?.paciente?.pessoa?.nome}`], ["GÊNERO: " + `${item.orcamento?.homecare?.paciente?.sexo}`], ["NASC.: " + `${item.orcamento.homecare.paciente.pessoa.nascimento}`]],
        [["CPF: " + `${item.orcamento?.homecare?.paciente?.pessoa?.cpfcnpj}`], ["RG: " + `${item.orcamento?.homecare?.paciente?.pessoa?.rgie}`], []],
      ],
      startY: doc.lastAutoTable.finalY += 5,
      theme: 'grid',
      tableWidth: 'auto',
    });
    //   //Especialidades
    let itensServicoOrcamento = [];
    for (let i = 0; i < item.orcamento.servicos.length; i++) {
      itensServicoOrcamento.push([
        i + 1,
        item.orcamento.servicos[i].descricao,
        item.orcamento.servicos[i].quantidade + ' ' + item.orcamento.servicos[i].basecobranca + ' ' + item.orcamento.servicos[i].frequencia,
        this.getFormattedPrice(item.orcamento.servicos[i].custo)
      ])
    }
    ((doc as any).autoTable)({
      head: [[{ colSpan: 4, content: "Serviços: " }],],
      body: itensServicoOrcamento,
      startY: doc.lastAutoTable.finalY += 5,
      theme: 'grid',
      tableWidth: 'auto',
    });

    //   //MAT/MED/Equi
    let itensProdutoOrcamento = [];
    for (let i = 0; i < item.orcamento.produtos.length; i++) {
      itensProdutoOrcamento.push([
        i + 1,
        item.orcamento.produtos[i].descricao,
        item.orcamento.produtos[i].quantidade,
        this.getFormattedPrice(item.orcamento.produtos[i].custo),
      ])
    }
    ((doc as any).autoTable)({
      head: [[{ colSpan: 3, content: "MAT/MED/EQUIPAMENTOS" }],],
      body: itensProdutoOrcamento,
      startY: doc.lastAutoTable.finalY += 5,
      theme: 'grid',
      tableWidth: 'auto',
    });

    //OBS
    ((doc as any).autoTable)({
      head: [["Observações/Diagnóstico inicial"]],
      body: [
        [item.orcamento.observacao],

      ],
      startY: doc.lastAutoTable.finalY += 5,
      theme: 'grid',
      tableWidth: 'auto',
    });
    for (let i = 1; i < pdf_pages.length; i++) {
      doc.setPage(i)
      // this.pdfService.headerFooterPage(doc, i, "Contrato", usuario, logo)

    }
    doc.save("OS" + `${item.orcamento.homecare.paciente.pessoa.nome}.pdf`);
  }
  getFormattedPrice(price: number) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(price);
  }
  headerFooterPage(doc: jsPDF, nPage, titulo: string, empresa: any, logo: any) {
    var pageSize = doc.internal.pageSize;
    var footerAmi = new ImagensBase64();
    let usuario: any = []
    if (empresa?.user.pessoa.profissional) usuario = empresa.user.pessoa.profissional.empresa
    if (empresa?.user.pessoa.cliente) usuario = empresa.user.pessoa.cliente.empresa
    if (empresa?.user.pessoa.responsavel) usuario = empresa.user.pessoa.responsavel.empresa
    // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
    var width = doc.internal.pageSize.width;
    var height = doc.internal.pageSize.height;
    doc.setTextColor(0, 0, 0)
    doc.setFontType('normal')
    if (logo.logopdf) {
      doc.addImage(`data:image/png;base64,${logo.logopdf}`, 'JPEG', 10, 5, 0, 15)
    }
    doc.setFontSize(8)
    doc.text(`${usuario?.razao.toUpperCase()}`, doc.internal.pageSize.getWidth() / 2, 10, { align: "center" });
    doc.text(`CNPJ: ${usuario?.cnpj}`, doc.internal.pageSize.getWidth() / 2, 15, { align: "center" });
    // doc.addImage(`data:image/png;base64,${logoLife.empresas.find(x => x.id == 2).logo}`, 'JPEG', 176, 5, 24, 0)
    doc.text(`Data: ${new DatePipe("pt-BR").transform(Date.now(), 'dd/MM/yyyy H:mm')}`, width - 10, 10, { align: "right" });
    doc.text(`Usuário: ${empresa?.user?.pessoa?.nome}`, width - 10, 15, { align: "right" });
    doc.setFontSize(10)
    doc.setFontType('bold')
    if (usuario.id == 9) { // AMI id = 9
      doc.setTextColor(115, 121, 226)
    } else {
      doc.setTextColor(2, 50, 54)
    }
    doc.text(`${titulo}`, doc.internal.pageSize.getWidth() / 2, 25, { align: "center" })
    if (usuario.id == 9) { // AMI id = 9
      doc.setDrawColor(155, 64, 60) // draw red lines ["AUXILIAR DE ENFERMAGEM"]["2020-10-01"][0].ordemservico.orcamento.homecare.paciente.sexo
    } else {
      doc.setDrawColor(2, 50, 54) // draw red lines ["AUXILIAR DE ENFERMAGEM"]["2020-10-01"][0].ordemservico.orcamento.homecare.paciente.sexo
    }
    doc.setLineWidth(0.5)
    doc.line(10, 28, width - 10, 28)
    doc.setLineWidth(0.1)


    //FOOTER
    var str = doc.internal.getNumberOfPages()
    doc.setFontType('normal')
    // doc.setTextColor(255, 255, 255)
    if (usuario.id == 9) { // AMI id = 9
      doc.setFontType('bold')
      doc.setTextColor(155, 64, 60)
      doc.setDrawColor(155, 64, 60)
      doc.addImage(`data:image/png;base64,${footerAmi.footerAmi}`, 'JPEG', 0, height == 297.0000833333333 ? 285 : 198, width, 20)
    } else {
      // doc.setTextColor(2, 50, 54)
      doc.setTextColor(0, 0, 0)
      doc.setDrawColor(2, 50, 54)
    }
    doc.setLineWidth(0.5)
    doc.line(0, height == 297.0000833333333 ? 285 : 198, width, height == 297.0000833333333 ? 285 : 198)
    doc.setLineWidth(0.1)
    doc.setFontSize(10);
    doc.text(`${usuario?.endereco ? usuario?.endereco : 'Endereço'}`, 2, height == 297.0000833333333 ? 290 : 203);
    doc.text(`${usuario?.telefone ? usuario?.telefone : ''} - ${usuario?.celular ? usuario?.celular : ''}`, 2, height == 297.0000833333333 ? 295 : 208);
    doc.text("" + nPage, doc.internal.pageSize.getWidth() / 2, height == 297.0000833333333 ? 293 : 206);
    doc.text(`${usuario?.email ? usuario?.email : ''} `, width - 2, height == 297.0000833333333 ? 290 : 203, { align: "right" });
    doc.text(`${empresa?.site ? empresa?.site : ''}`, width - 2, height == 297.0000833333333 ? 295 : 208, { align: "right" });
    // doc.text(`${empresa?.endereco} - ${empresa?.telefone} - ${empresa?.celular} - ${empresa?.email} - ${empresa?.site}`, doc.internal.pageSize.getWidth() / 2, 294, { align: "center" });
    // doc.text("19 - 37929888 Tel 19 - 997032341", 80, 294);
    // doc.text("", 100, 294);
    // doc.text(" ", 130, 294);
    // doc.text("", 170, 294);

  }
}
